(function () {
    "use strict";
    function productParameters() {
        const productCards = document.querySelectorAll('.collection-product-card')
        productCards.forEach(card => {
            const productParameters = card.querySelector('.product-parameters');
          
            if (productParameters) {
                const width = productParameters.offsetWidth;
                console.log('Product Parameters Width:', width + 'px');
                const labelWidth = card.querySelector('.variant-swatch.bg_size-portrait').offsetWidth;
                console.log('Label Width:', labelWidth + 'px');
                const availableWidth = width - 45;
                const numberOfLabels = Math.floor(availableWidth / labelWidth);
                const totalLabels = productParameters.querySelectorAll('.variant-swatch.bg_size-portrait');
                const totalLabelsCount = totalLabels.length;
                const oldMoreLabels =productParameters.querySelector('.more-labels');
                if (oldMoreLabels) {
                    oldMoreLabels.remove();
                }
                if (totalLabelsCount > numberOfLabels) {
                    const hiddenLabels = totalLabelsCount - numberOfLabels;            
                    const moreLabels = document.createElement('a');
                    moreLabels.href = card.querySelector('.card__title a').href;
                    moreLabels.className = 'more-labels';
                    moreLabels.textContent = `+${hiddenLabels} more`;
                    productParameters.appendChild(moreLabels);
                }

                totalLabels.forEach((label, index) => {
                    if (index >= numberOfLabels) {
                        label.style.display = 'none';
                    } else {
                        label.style.display = 'block';
                    }
                });
            }
        });
    }

    function productParametersOnResize() {
        window.addEventListener('resize', productParameters);
    }

    function onDOMContentLoaded() {
        // Call it unconditionally
        productParameters();
        productParametersOnResize();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", onDOMContentLoaded, { once: true });
    } else {
        onDOMContentLoaded();
    }
})();